export const REVIEW_TYPES = {
  COMPANY: 'company', // synonym of `overview`
  OVERVIEW: 'overview',
  EMPLOYEE: 'employee',
  INTERVIEW: 'interview',
};

export default REVIEW_TYPES;
